import React, { useEffect, useMemo, useRef } from "react";
import { Chart, registerables } from "chart.js";
import { getPerformanceChartConfig } from "../../ChPerformanceReportHelperLib/chPerformanceChartHelper";
import {
    aggregateChartBuckets,
    TIME_BUCKET_LABELS,
    latenessLabels,
    CHART_TYPES,
} from "../../ChPerformanceReportHelperLib/chPerformanceDataHelper";
import styles from "./chPerformanceReport.module.css";

Chart.register(...registerables);

const ChPerformanceSingleChart = ({
    type,
    title,
    companyCharts,
    companySummaries,
    selectedCompanyIds,
    onBarClick,
    highlightedBucketIndex,
    onTimeBufferMinutes = 0,
}) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);

    const { barData, lineData } = useMemo(
        () => aggregateChartBuckets(
            companyCharts ?? {},
            type,
            companySummaries ?? {},
            selectedCompanyIds ?? null,
        ),
        [companyCharts, companySummaries, selectedCompanyIds, type]
    );

    useEffect(() => {
        if (!chartRef.current) return;

        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
            chartInstanceRef.current = null;
        }

        const labels = type === CHART_TYPES.LATENESS ? latenessLabels(onTimeBufferMinutes) : TIME_BUCKET_LABELS;
        const canvasCtx = chartRef.current.getContext('2d');
        const handleBarClick = onBarClick
            ? (bucketIndex) => onBarClick(type, bucketIndex)
            : null;
        const config = getPerformanceChartConfig(barData, lineData, title, labels, canvasCtx, handleBarClick, highlightedBucketIndex ?? null);

        chartInstanceRef.current = new Chart(chartRef.current, config);

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [barData, lineData, type, title, onBarClick, highlightedBucketIndex, onTimeBufferMinutes]);

    return (
        <div className={styles.chartContainer}>
            <canvas ref={chartRef} />
        </div>
    );
};

export default ChPerformanceSingleChart;
